import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Each production region is a fully separate Foundation instance (users, accounts, and data do not cross regions).
const environments = {
  0: { name: 'Local', hostUrl: 'https://localhost:8499/api/crudy/', platformUrl: 'https://localhost:8081/' },
  1: { name: 'Test', hostUrl: 'https://foundation-test.textel.net/api/crudy/', platformUrl: 'https://app-test.textel.net/' },
  2: { name: 'Production', hostUrl: 'https://foundation.textel.net/api/crudy/', platformUrl: 'https://app.textel.net/' },
  3: { name: 'FR - Production', hostUrl: 'https://foundation.textel.eu/api/crudy/', platformUrl: 'https://app.textel.eu/' },
  4: { name: 'UK - Production', hostUrl: 'https://foundation.textel.uk/api/crudy/', platformUrl: 'https://app.textel.uk/' },
};

export default new Vuex.Store({
  state: {
    environment: 0,
    environmentDictionary: Object.fromEntries(Object.entries(environments).map(([key, value]) => [key, value.name])),
    hostUrl: 'https://localhost:8499/api/crudy/',
    platformUrl: 'https://localhost:8081/',
    accountFilters: {
      searchTerm: '',
      page: 0,
      status: null,
      integration: null
    },
    userFilters: {
      searchTerm: '',
      page: 0,
      accountPublicId: null,
      userRole: null,
      userStatus: null
    },
    lineFilters: {
      searchTerm: '',
      page: 0,
      accountPublicId: null,
      integration: null,
      textingService: null,
      isEnabled: null,
    },
    jobHistoryFilters: {
      page: 0,
      filterByUser: false,
    },
  },
  mutations: {
    updateEnvironment(state, environment) {
      const selectedEnvironment = environments[environment];

      // Ignore unknown values (e.g. a stale id left in localStorage) rather than pointing at an undefined host.
      if (!selectedEnvironment) {
        return;
      }

      state.environment = environment;
      state.hostUrl = selectedEnvironment.hostUrl;
      state.platformUrl = selectedEnvironment.platformUrl;

      localStorage.setItem("environment", environment);
    },
    updateAccountSearchFilter(state, searchTerm) {
      state.accountFilters.searchTerm = searchTerm;
    },
    updateAccountPageFilter(state, page) {
      state.accountFilters.page = page;
    },
    updateAccountStatusFilter(state, status) {
      state.accountFilters.status = status;
    },
    updateAccountIntegrationFilter(state, integration) {
      state.accountFilters.integration = integration;
    },
    updateUserSearchFilter(state, searchTerm) {
      state.userFilters.searchTerm = searchTerm;
    },
    updateUserPageFilter(state, page) {
      state.userFilters.page = page;
    },
    updateUserAccountIdFilter(state, id) {
      state.userFilters.accountPublicId = id;
    },
    updateUserRoleFilter(state, role) {
      state.userFilters.userRole = role;
    },
    updateUserStatusFilter(state, status) {
      state.userFilters.userStatus = status;
    },
    updateLineSearchFilter(state, searchTerm) {
      state.lineFilters.searchTerm = searchTerm;
    },
    updateLinePageFilter(state, page) {
      state.lineFilters.page = page;
    },
    updateLineAccountIdFilter(state, id) {
      state.lineFilters.accountPublicId = id;
    },
    updateJobHistoryPageFilter(state, page) {
      state.jobHistoryFilters.page = page;
    },
    updateJobHistoryFilterByUser(state, filterByUser) {
      state.jobHistoryFilters.filterByUser = filterByUser;
    },
    updateLineIntegrationFilter(state, integration) {
      state.lineFilters.integration = integration;
    },
    updateLineTextingServiceFilter(state, textingService) {
      state.lineFilters.textingService = textingService;
    },
    updateLineIsEnabledFilter(state, isEnabled) {
      state.lineFilters.isEnabled = isEnabled;
    }
  },
  actions: {
    clearAccountFilters(context) {
      context.commit('updateAccountSearchFilter', '');
      context.commit('updateAccountPageFilter', 0);
      context.commit('updateAccountStatusFilter', null);
      context.commit('updateAccountIntegrationFilter', null);
    },
    clearUserFilters(context) {
      context.commit('updateUserSearchFilter', '');
      context.commit('updateUserPageFilter', 0);
      context.commit('updateUserAccountIdFilter', null);
      context.commit('updateUserRoleFilter', null);
      context.commit('updateUserStatusFilter', null);
    },
    clearLineFilters(context) {
      context.commit('updateLineSearchFilter', '');
      context.commit('updateLinePageFilter', 0);
      context.commit('updateLineAccountIdFilter', null);
      context.commit('updateLineIntegrationFilter', null);
      context.commit('updateLineTextingServiceFilter', null);
      context.commit('updateLineIsEnabledFilter', null);
    },
    clearJobHistoryFilters(context) {
      context.commit("updateJobHistoryPageFilter", 0);
    },
  },
  modules: {
  }
})
